import { type RefObject, useCallback, useRef } from "react";

import {
  CarouselArrowDirection,
  RMC_ARROW_SELECTORS
} from "@/src/pages/consumer/HomePage/HomePageImageCarousel/homePageImageCarousel.constants";

export interface CarouselArrowController {
  wrapperRef: RefObject<HTMLDivElement | null>;
  triggerArrow: (direction: CarouselArrowDirection) => void;
}

const useCarouselArrowController = (): CarouselArrowController => {
  const wrapperRef = useRef<HTMLDivElement | null>(null);

  const triggerArrow = useCallback((direction: CarouselArrowDirection) => {
    const wrapper = wrapperRef.current;
    if (!wrapper) return;
    const arrow = wrapper.querySelector<HTMLButtonElement>(
      RMC_ARROW_SELECTORS[direction]
    );
    arrow?.click();
  }, []);

  return { wrapperRef, triggerArrow };
};

export default useCarouselArrowController;
